import { render } from "./articleList.vue?vue&type=template&id=dd090ada&scoped=true&ts=true"
import script from "./articleList.vue?vue&type=script&lang=ts"
export * from "./articleList.vue?vue&type=script&lang=ts"

import "./articleList.vue?vue&type=style&index=0&id=dd090ada&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd090ada"]])

export default __exports__